import React, { useContext } from 'react';
import { Link, useParams } from 'react-router-dom';
import { LanguageContext } from '../LanguageContext';
import projets from '../projets';

const ProjetDetail = () => {
  const { slug } = useParams();
  const { language, t } = useContext(LanguageContext);
  const index = projets.findIndex((p) => p.slug === slug);

  if (index === -1) {
    return (
      <div className="page container">
        <Link to="/projets" className="back">{t.projects.back}</Link>
        <header className="page__head">
          <h1>{t.notFound.title}</h1>
          <p>{t.notFound.text}</p>
        </header>
      </div>
    );
  }

  const projet = projets[index];
  const next = projets[(index + 1) % projets.length];
  const description = projet.description[language];
  const meta = [projet.type[language], projet.place, projet.year].filter(Boolean).join(' · ');

  // Fiche technique : les lignes sans valeur dans la langue courante sont ignorées
  const facts = (projet.facts || []).filter((f) => f.value && f.value[language]);

  // Évite une image orpheline seule sur sa ligne dans la galerie
  const last = projet.gallery.length - 1;
  const isWide = (i) => i === 0 || (i === last && last % 2 === 1);

  return (
    <div className="page container">
      <Link to="/projets" className="back">{t.projects.back}</Link>

      <header className="page__head">
        {meta && <p className="eyebrow">{meta}</p>}
        <h1>{projet.name[language]}</h1>
        <p>{description || t.projects.empty}</p>
      </header>

      {facts.length > 0 && (
        <section className="facts" aria-labelledby="facts-title">
          <h2 id="facts-title" className="facts__title">{t.projects.factsTitle}</h2>
          <dl className="facts__list">
            {facts.map((f) => (
              <div key={f.label.fr} className="facts__row">
                <dt>{f.label[language]}</dt>
                <dd>{f.value[language]}</dd>
              </div>
            ))}
          </dl>
        </section>
      )}

      <div className="gallery">
        {projet.gallery.map((src, i) => (
          <figure key={src + i} className={isWide(i) ? 'gallery__item gallery__item--wide' : 'gallery__item'}>
            <img
              src={src}
              alt={`${projet.name[language]} ${i + 1}`}
              loading={i === 0 ? 'eager' : 'lazy'}
            />
          </figure>
        ))}
      </div>

      <div className="next">
        <Link to={`/projets/${next.slug}`} className="btn btn--dark">{t.projects.next}</Link>
      </div>
    </div>
  );
};

export default ProjetDetail;
